// extracted by mini-css-extract-plugin
export default {"uiTpaColoPicker":"UKyaAS","description":"OINeio","colorOptions":"BnCaD8","title":"raPW8O","productOptionsColorContainer":"sjaM8t","actionable":"s_PrLG","colorSamplerGroup":"eP4wAY"};